import { proxy } from 'valtio';

import { TIMER_DEFAULT_TIME } from '@canvas/constants/elements/timer';

type TimerStateProperties = {
  startTimeUTCMilliSeconds?: number;
  durationMilliSeconds: number;
  elapsedTimeMilliSeconds: number;
  paused: boolean;
  serverTimeOffset: number;
};

export type TimerProperties = TimerStateProperties;

export const defaultTimer: TimerStateProperties = {
  durationMilliSeconds: TIMER_DEFAULT_TIME,
  elapsedTimeMilliSeconds: 0,
  paused: false,
  serverTimeOffset: 0,
};

export const currentTimer: TimerProperties = proxy(defaultTimer);

export const updateTimerStartTimeUTCMilliSeconds = (
  startTimeUTCMilliSeconds: number | undefined,
) => (currentTimer.startTimeUTCMilliSeconds = startTimeUTCMilliSeconds);

export const updateTimerDurationMilliseconds = (durationMilliSeconds: number) =>
  (currentTimer.durationMilliSeconds = durationMilliSeconds);

export const updateTimerElapsedTimeMilliSeconds = (elapsedMilliSeconds: number) =>
  (currentTimer.elapsedTimeMilliSeconds = elapsedMilliSeconds);

export const updateTimerPaused = (paused: boolean) => (currentTimer.paused = paused);

export const updateServerTimeOffset = (serverTimeOffset: number) => {
  currentTimer.serverTimeOffset = serverTimeOffset;
};
